import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtilsService, QueryParamsModel } from 'app/core/_base/crud';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
const API_ROOT_URL = environment.ApiRoot + '/bao-cao-chi-tiet-don-hang-ban';
@Injectable()
export class BaoCaoChiTietDonHangBanService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import: BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(
		private http: HttpClient,
		private httpUtils: HttpUtilsService
	) { }
	getData(queryParams: QueryParamsModel): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/BaoCaoChiTietDHB', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	listId_NhomHH(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + `/DM_NhomHangHoa_List?idLoaiHH=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	listDVT1(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/danhmuc' + '/DM_DVT_List';
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	listBoPhanKiemTra(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/danhmuc' + '/DM_PhongBan_List';
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	listListNCC(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/danhmuc' + '/DM_NCC_List';
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	listListKH(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/danhmuc' + '/DM_KhachHangCha_List';
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	listThanhPham(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + '/ListThanhPham';
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	listTonKhoHangHoaTheoBOM(idHH, idChiTietPO = -1): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		let url = `${environment.ApiRoot}/dungchung/HHTonKhoTheoBOM_List?idHH=${idHH}`;
		if (idChiTietPO > -1)
			url = `${environment.ApiRoot}/dungchung/HHTonKhoTheoBOM_List?idHH=${idHH}&idChiTietPO=${idChiTietPO}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getSoPhieuDHB(idCt): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PO_Lite?idCt=${idCt}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
}
